var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"scale-grid tiles flex flex-row flex-wrap items-start",attrs:{"id":"scale-grid","name":"scale-grid","tag":"div"}},[_vm._t("default",null,null,{ size: _vm.size, full: _vm.full })],2)}
var staticRenderFns = []

export { render, staticRenderFns }